// Content Platform — AUTHORED per-service content (the Owner's content slot).
//
// Services with an authored module render its blocks; every other service falls back to the factual
// default (defaultServiceBlocks). Add `{ blocks: [...] }` keyed by the ratified slug — the build-time
// validator enforces the schema, fail-closed.
//
// GOVERNANCE: authored content is PRESENTATION DATA ONLY. It must NOT restate or import business
// facts/identity (areaServed, SIREN, etc. live in sabProfile / companyLegalIdentity). Blocks compose
// approved data via the default builder; authored modules add copy, not facts.
//
// Service Content Program — authored service pages (golden pattern: airport-transfer / PR #250).

import airportTransfer from './airport-transfer.js';
import stationTransfer from './station-transfer.js';
import businessChauffeur from './business-chauffeur.js';
import chauffeurByTheHour from './chauffeur-by-the-hour.js';
import eventChauffeur from './event-chauffeur.js';
import hotelTransfer from './hotel-transfer.js';
import longDistanceTransfer from './long-distance-transfer.js';

export const AUTHORED_SERVICE_CONTENT = Object.freeze({
  'airport-transfer': airportTransfer,
  'station-transfer': stationTransfer,
  'business-chauffeur': businessChauffeur,
  'chauffeur-by-the-hour': chauffeurByTheHour,
  'event-chauffeur': eventChauffeur,
  'hotel-transfer': hotelTransfer,
  'long-distance-transfer': longDistanceTransfer,
});
